import { Stack } from '@sixui/ui';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IContentBlockBodyProps = IContainerProps & {
  children: React.ReactNode;
  first?: boolean;
  extended?: boolean;
};

const styles = stylex.create({
  host: {
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    paddingBottom: '1.5rem',
  },
  host$first: {
    paddingTop: '1.5rem',
  },
  host$extended: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0,
  },
});

export const ContentBlockBody: React.FC<IContentBlockBodyProps> = (props) => {
  const { sx, children, first, extended } = props;

  return (
    <Stack
      gap={4}
      sx={[
        styles.host,
        first && styles.host$first,
        extended && styles.host$extended,
        sx,
      ]}
    >
      {children}
    </Stack>
  );
};
